export enum UserManagementFormType {
  Standard,
  OnlyEditNestsActivity,
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-models/user-management-form-type.ts